//let formMetas = document.forms[0];

import calculo from "./calculo";

function calculadoraDeMetas(formMetas) {
    formMetas.addEventListener("change", (event) => {
        calculaNumTurmas();
        calculaNumAlunosTurmas();
        calculaCargaHoraria();
        // totais de residuais/novas são calculados por calculadora_residuais.js,
        // via onChange do React no <tbody> (FormMetasMensaisContainer/index.js)
        calculaNumTotalMatriculas();
        calculaHoraAluno();
        calculaCargaHorariaTurmaAno();
        calculaNecessidadeDocente8H();
        calculaNecessidadeDocente7H();
        calculaTotalMatriculasPorMes();
        calculaHoraAlunoPorMes();
        calculaCargaHorariaTurmaAnoPorMes();
        calculaNecessidadeDocente8HPorMes();
        calculaNecessidadeDocente7HPorMes();
        ditribuirHoraAlunoV2();
        calculaHoraAlunoDistribuidaTotal();
    });
}

function ditribuirHoraAlunoV2() {

    let modalidade = document.getElementById("data-modalidade").dataset.modalidade
    
    let diasLetivosUnidades = [ 5, 19, 15, 19, 20, 14, 17, 18, 21, 20, 19, 14 ]
    let diasLetivosFaculdade = [ 0, 16, 18, 21, 20, 15, 0, 20, 20, 19, 19, 15 ]
    let diasLetivos = window.location.pathname.includes("faculdade") && !modalidade.startsWith('Cursos de Extensão') ? diasLetivosFaculdade : diasLetivosUnidades

    let diasLetivosQuadriAnual = [...diasLetivos, ...diasLetivos, ...diasLetivos, ...diasLetivos]

    let totalDiasLetivos = diasLetivos.reduce((acc, atual) => acc + atual, 0)

    let percentualAnoLetivo = diasLetivos.map(dias => {
        let percent = dias === 0 ? 0 : dias / totalDiasLetivos
        return percent
    })

    let totalPercentual = percentualAnoLetivo.reduce((acc, atual) => acc + atual, 0)

    let dataInicio = getArrayFromClassName('dataInicio');
    let dataFim = getArrayFromClassName('dataFim');
    let horaAluno = getArrayFromClassName('horaAluno');
    let horaAlunoDistribuida = document.getElementsByClassName('horaAlunoDistribuida');

    let horaAlunoDistribuidaFill = new Array(12).fill(0)

    for (const [i, hora] of horaAluno.entries()) {
        
        let totalHoraAlunoDistribuida = calculaHoraAlunoDistribuidaTotalV2();
        let TotalHoras = 0
        
        let { diffDays, diffTime, diffTotalMeses } = calculo.getDataDiff(dataInicio[i], dataFim[i]);

        let horasRestantes = 0 // Horas que faltam distribuir

        let limiteMeses = i + diffTotalMeses;
        percentualAnoLetivo = limiteMeses <= 12 ? calculo.verificaPercentualAnual(diasLetivos, limiteMeses, i) : calculo.verificaPercentualAnual(diasLetivosQuadriAnual, limiteMeses, i)

        for(let iter = i; iter < limiteMeses; iter++) {
            
            let total = hora * percentualAnoLetivo[iter]
            let totalFloor = Math.floor(total) // Distribuição em números inteiros

            horasRestantes += total - totalFloor // Horas que faltam distribuir
            TotalHoras += totalFloor

            horaAlunoDistribuidaFill[iter] += totalFloor

        }

        // Adicionar horas restantes ao último mês da distribuição
        horasRestantes = Math.ceil(horasRestantes)
        let totalHorasRestantes = (horasRestantes + TotalHoras) - totalHoraAlunoDistribuida === 1 ? horasRestantes-1 : horasRestantes
        horaAlunoDistribuidaFill[limiteMeses - 1] += totalHorasRestantes;

    }

    Array.from(horaAlunoDistribuida).forEach((v, i) => v.value = horaAlunoDistribuidaFill[i])

}

function calculaHoraAlunoDistribuidaTotal() {
    let numTurmas = document.getElementsByClassName("horaAlunoDistribuida");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalHoraAlunoDistribuida").value = total;
}

function calculaHoraAlunoDistribuidaTotalV2() {
    let numTurmas = document.getElementsByClassName("horaAlunoDistribuida");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    return total;
}

function getArrayFromClassName(valorAtributo) {
    let arryaAttr = document.getElementsByClassName(valorAtributo);
    arryaAttr = Array.from(arryaAttr).map(data => data.value);
    return arryaAttr
}

function calculaNumTurmas() {
    let numTurmas = document.getElementsByClassName("numTurmas");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNumTurmas").value = total;
}

function calculaNumAlunosTurmas() {
    let numTurmas = document.getElementsByClassName("numAlunosTurmas");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNumAlunosTurmas").value = total;
}

function calculaCargaHoraria() {
    let numTurmas = document.getElementsByClassName("cargaHoraria");
    numTurmas = Array.from(numTurmas);
    /*
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalCargaHoraria").value = total;
    */
   let total = numTurmas.filter(valor => {
       if(valor.value > 0) return valor.value;
   });
   total = total.length > 0 ? Number(total[0].value) : 0
   document.getElementById("totalCargaHoraria").value = total;
}

function calculaNumTotalMatriculas() {
    let numTurmas = document.getElementsByClassName("numTotalMatriculas");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNumTotalMatriculas").value = total;
}

function calculaHoraAluno() {
    let numTurmas = document.getElementsByClassName("horaAluno");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalHoraAluno").value = total;
}

function calculaCargaHorariaTurmaAno() {
    let numTurmas = document.getElementsByClassName("cargaHorariaTurmaAno");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalCargaHorariaTurmaAno").value = total;
}

function calculaNecessidadeDocente8H() {
    let numTurmas = document.getElementsByClassName("necessidadeDocente8H");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNecessidadeDocente8H").value = total;
}

function calculaNecessidadeDocente7H() {
    let numTurmas = document.getElementsByClassName("necessidadeDocente7H");
    numTurmas = Array.from(numTurmas);
    let total = numTurmas.reduce((acc, atual) => {
        atual = Number.parseFloat(atual.value) || 0
        return acc + atual
    }, 0)
    document.getElementById("totalNecessidadeDocente7H").value = total;
}

function calculaTotalMatriculasPorMes() {

    let numMatriculasResiduais = document.getElementsByClassName("numMatriculasResiduais");
    let numMatriculasNovas = document.getElementsByClassName("numMatriculasNovas");
    let numTotalMatriculas = document.getElementsByClassName("numTotalMatriculas");

    numMatriculasResiduais = Array.from(numMatriculasResiduais);
    numMatriculasNovas = Array.from(numMatriculasNovas);
    numTotalMatriculas = Array.from(numTotalMatriculas);
    
    numTotalMatriculas.map((valor, index) => {
        let v1 = numMatriculasResiduais[index].value;
        let v2 = numMatriculasNovas[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        v2 = v2 === "" ? 0 : Number.parseFloat(v2);
        valor.value = v1 + v2;
    });

    calculaNumTotalMatriculas();
}

function calculaHoraAlunoPorMes() {

    let cargaHoraria = document.getElementsByClassName("cargaHoraria");
    let numTotalMatriculas = document.getElementsByClassName("numTotalMatriculas");
    let horaAluno = document.getElementsByClassName("horaAluno");

    cargaHoraria = Array.from(cargaHoraria);
    numTotalMatriculas = Array.from(numTotalMatriculas);
    horaAluno = Array.from(horaAluno);
    
    horaAluno.map((valor, index) => {
        let v1 = cargaHoraria[index].value;
        let v2 = numTotalMatriculas[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        v2 = v2 === "" ? 0 : Number.parseFloat(v2);
        valor.value = v1 * v2;
    });

    calculaHoraAluno();
}

/*
function calculaCargaHorariaTurmaAnoPorMes() {
    let cargaHoraria = document.getElementsByClassName("cargaHoraria");
    let cargaHorariaTurmaAno = document.getElementsByClassName("cargaHorariaTurmaAno");

    cargaHoraria = Array.from(cargaHoraria);
    cargaHorariaTurmaAno = Array.from(cargaHorariaTurmaAno);
    
    cargaHorariaTurmaAno.map((valor, index) => {
        let v1 = cargaHoraria[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        valor.value = v1 * 0.20;
    });

    calculaCargaHorariaTurmaAno();
}
*/
function calculaCargaHorariaTurmaAnoPorMes() {
    let cargaHoraria = document.getElementsByClassName("cargaHoraria");
    let cargaHorariaTurmaAno = document.getElementsByClassName("cargaHorariaTurmaAno");
    let numTurmas = document.getElementsByClassName("numTurmas");

    cargaHoraria = Array.from(cargaHoraria);
    cargaHorariaTurmaAno = Array.from(cargaHorariaTurmaAno);
    numTurmas = Array.from(numTurmas);
    
    cargaHorariaTurmaAno.map((valor, index) => {
        let v1 = cargaHoraria[index].value;
        let v2 = numTurmas[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        v2 = v2 === "" ? 0 : Number.parseFloat(v2);
        valor.value = v1 * v2;
    });

    calculaCargaHorariaTurmaAno();
}

function calculaNecessidadeDocente8HPorMes() {
    let necessidadeDocente8H = document.getElementsByClassName("necessidadeDocente8H");
    let cargaHorariaTurmaAno = document.getElementsByClassName("cargaHorariaTurmaAno");

    necessidadeDocente8H = Array.from(necessidadeDocente8H);
    cargaHorariaTurmaAno = Array.from(cargaHorariaTurmaAno);
    
    necessidadeDocente8H.map((valor, index) => {
        let v1 = cargaHorariaTurmaAno[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        //valor.value = (v1 / 200 / 8).toLocaleString("pt-br", { maximumFractionDigits: 2 });
        valor.value = (v1 / 200 / 8).toPrecision(1);
    });

    calculaNecessidadeDocente8H();
}

function calculaNecessidadeDocente7HPorMes() {
    let necessidadeDocente8H = document.getElementsByClassName("necessidadeDocente7H");
    let cargaHorariaTurmaAno = document.getElementsByClassName("cargaHorariaTurmaAno");

    necessidadeDocente8H = Array.from(necessidadeDocente8H);
    cargaHorariaTurmaAno = Array.from(cargaHorariaTurmaAno);
    
    necessidadeDocente8H.map((valor, index) => {
        let v1 = cargaHorariaTurmaAno[index].value;
        v1 = v1 === "" ? 0 : Number.parseFloat(v1);
        //v1 = (v1 / 200 / 7.2).toLocaleString("pt-br", { maximumFractionDigits: 2 });
        valor.value = (v1 / 200 / 7.2).toPrecision(1);
    });

    calculaNecessidadeDocente7H();
}

// Executa a calculadora de metas
window.addEventListener("load", function () {
    let formMetas = document.forms[0];
    if(document.getElementById("formMetasMensais")) {
        calculadoraDeMetas(formMetas);
    }
});
